import img6 from "../assets/images/destination-sl.jpg";
import img7 from "../assets/images/otherTours-img.jpg";

const destinationDropdownItems = [
  {
    path: "dmc-services",
    imageSrc: img6,
    altText: "dmc-services",
    label: "DMC SERVICES",
  },
  {
    path: "mice-services",
    imageSrc: img7,
    altText: "Mice Services",
    label: "MICE SERVICES",
  },
  {
    path: "https://plusairfare.com/",
    imageSrc: img7,
    altText: "Destinations",
    label: "BOOK FLIGHTS",
  }
];

export default destinationDropdownItems;